import { Button } from '@components/ui/button/Button';
import { faArrowRotateRight, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ErrorStateProps {
    error: Error | null;
    onRetry: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
    return (
        <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
            <div className="mb-4 text-destructive">
                <FontAwesomeIcon icon={faExclamationTriangle} className="h-12 w-12" />
            </div>
            <h3 className="text-lg font-semibold mb-2 text-foreground">
                Error al cargar los datos
            </h3>
            <p className="text-sm text-muted-foreground mb-6 max-w-md">
                {error?.message || 'Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.'}
            </p>
            <Button onClick={onRetry} variant="outline" className="transition-colors">
                <FontAwesomeIcon icon={faArrowRotateRight} className="mr-2 h-4 w-4" />
                Reintentar
            </Button>
        </div>
    );
};

